// extracted by mini-css-extract-plugin
export var pillWrapper = "_n6-0";
export var showOverflow = "_n6-1";